"use client";

import React, { useState, useEffect, useRef } from "react";
import { AnimatePresence, domAnimation, LazyMotion, m } from "framer-motion";
import { ArrowIcon } from "./HomeFilterSearch";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";

import { useMemo } from "react";
// import Select from "../../../ui/Form/Select/select2";
import { statesData } from "../../../constants/statesData";
import { PropertyType } from "../../design1/components/HeroSearchComponent";
import { useRouter } from "next/navigation";
import {
  PropertySearchData,
  getPriceRanges,
} from "../../design1/components/HeroSearchComponent";
import useUnitsData from "src/app/components/hooks/useUnitInfo";
import { useOutsideClick } from "src/app/components/hooks/useOutsideClick";

// interface PropertySearchProps {
//   propertyType: "" | "For sale" | "For rent" | "For shortlet";
// }

// interface PropertySearchFormProps {
//   type: PropertyType;
// }

export interface PropertySearchFormRef {
  handleSearch: () => void;
}

const PropertySearchForm = forwardRef<
  PropertySearchFormRef,
  { type: PropertyType; search: string }
>(({ type, search }, ref) => {
  const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
  const router = useRouter();
  const [isActive, setIsActive] = useState("lg");
  const { minPrices, maxPrices } = useMemo(() => getPriceRanges(type), [type]);


  const [formData, setFormData] = useState<PropertySearchData>({
    search: search,
    propertyType: type,
    category: "",
    unit_type: "",
    min_price: "",
    max_price: "",
    unit_sub_type: "",
    priceRange: "",
    state: "",
    local_government: "",
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      propertyType: type,
      min_price: "",
      max_price: "",
    }));
  }, [type, minPrices, maxPrices]);
  const targetDivRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (targetDivRef.current) {
        // const { top } = targetDivRef.current.getBoundingClientRect();
        // setIsAtTop(top <= 0); // True when the div reaches the top of the viewport
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleChange = (field: keyof PropertySearchData) => (value: string) => {
    setFormData((prevData) => {
      let updatedData = { ...prevData, [field]: value };

      if (field === "propertyType" && prevData.propertyType !== value) {
        updatedData = {
          ...updatedData,
          category: "",
          unit_type: "",
          unit_sub_type: "",
        };
      }
      if (field === "category" && prevData.category !== value) {
        updatedData = { ...updatedData, unit_type: "", unit_sub_type: "" };
      }
      if (field === "unit_type" && prevData.unit_type !== value) {
        updatedData = { ...updatedData, unit_sub_type: "" };
      }
      if (field === "state" && prevData.state !== value) {
        updatedData = {
          ...updatedData,
          local_government: "", // Reset localGovernment (lg)
        };
      }
      return updatedData;
    });
  };
  const handleSearch = () => {
    const { category, min_price, max_price, propertyType, ...filters } =
      formData; // Extract price and propertyType separately
    const params = new URLSearchParams();

    // append search
    filters.search = search;


    // Convert price values before adding them to params
    const convertPrice = (price: string) => {
      if (!price || price === "No Min" || price === "No Max") return "";
      return price
        .replace("₦", "")
        .replace(" Million", "000000")
        .replace(" Billion", "000000000")
        .replace(",", ""); // Remove commas
    };

    if (min_price) params.append("min_price", convertPrice(min_price));
    if (max_price) params.append("max_price", convertPrice(max_price));

    // Clean propertyType: remove "for" (e.g., "House for Sale" → "House Sale")
    const cleanPropertyType = (type: string) => {
      return type.replace(/\bfor\b/gi, "").trim();
    };

    if (category) params.append("category", category);

    // Append other filters if they have values
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });
    // Determine the base path
    let basePath = "/properties";
    if (
      propertyType &&
      ["rent", "sale", "shortlet"].includes(cleanPropertyType(propertyType))
    ) {
      basePath += `/${cleanPropertyType(propertyType).toLowerCase()}`;
    }

    // Construct full URL with query parameters
    const queryString = params.toString();
    const fullUrl = queryString ? `${basePath}?${queryString}` : basePath;
    router.push(fullUrl);
  };

  // Expose handleSearch to the parent
  useImperativeHandle(ref, () => ({
    handleSearch,
  }));

  const res = useUnitsData(); // Hook to fetch unit data
  const states = res.unitsData?.cleanedAreas;
  // const categories = Object.keys(propertyData);
  // const types = formData.category
  //   ? Object.keys(propertyData[formData.category])
  //   : [];
  // const subtypes =
  //   formData.category && formData.type
  //     ? propertyData[formData.category][formData.type]
  //     : [];
  const statesToMap = isDemo ? statesData : states;
  const stateNames = Array.isArray(statesToMap)
    ? statesToMap
        .map((state) => {
          const keys = Object.keys(state);
          return keys.length > 0 ? keys[0] : null;
        })
        .filter((key): key is string => key !== null)
    : [];
  // Get local governments for the selected state
  const selectedStateData = Array.isArray(statesToMap)
    ? statesToMap.find((state) =>
        Object.prototype.hasOwnProperty.call(state, formData.state)
      )
    : undefined;
  const localGovernments = selectedStateData
    ? Object.keys(
        selectedStateData[
          formData.state as keyof typeof selectedStateData
        ] as object
      )
    : [];
  return (
    <div
      ref={targetDivRef}
      className={`property-search-form  text-black flex shadow-sm`}
    >
      <div className="parent gap-10  w-full flex">
        <form className="flex w-full sm:flex-col justify-between  gap-[10px]">
          <div className="flex flex-1 sm:!w-full   xl:mx-auto xl:self-center xl:w-max justify-between xl:justify-center  items-center gap-4">
            <div className="items  flex-1  justify-between flex gap-4">
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsActive("lg");
                }}
                className="w-full "
              >
                <InputBtn isActive={isActive === "lg"} placeholder="Location" />
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setIsActive("range");
                }}
                className="w-full"
              >
                <InputBtn
                  isActive={isActive === "range"}
                  placeholder="Price Range"
                />
              </div>
            </div>
          </div>
          <div
            className={`all block  flex-1 xl:flex justify-between gap-3 lg:flex-col  `}
          >
            {/* <div className="items bg-yellow-700  justify-between  hidden xl:flex gap-4">
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (isActive === "lg") {
                    setIsActive("");
                    return;
                  }
                  setIsActive("lg");
                }}
                className=""
              >
                <InputBtn isActive={isActive === "lg"} placeholder="Location" />
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if (isActive === "range") {
                    setIsActive("");
                    return;
                  }
                  setIsActive("range");
                }}
                className=""
              >
                <InputBtn
                  isActive={isActive === "range"}
                  placeholder="Price Range"
                />
              </div>
            </div> */}
            {/* {isActive === "type" && formData.propertyType !== "" && (
              <div className="flex xl:justify-center  justify-between xs:gap-2 gap-4">
                <Select
                  placeholder="Select Category"
                  name="category"
                  value={formData.category}
                  options={categories}
                  onChange={handleChange("category")}
                />
                <Select
                  placeholder="Select Type"
                  name="type"
                  value={formData.type}
                  options={types}
                  onChange={handleChange("type")}
                />
                <Select
                  placeholder="Select Subtype"
                  name="subtype"
                  value={formData.subtype}
                  options={subtypes}
                  onChange={handleChange("subtype")}
                />
              </div>
            )} */}
            {isActive === "range" && (
              <div className="flex xl:justify-center xs:gap-2 justify-between gap-4">
                <Dropdown
                  placeholder="Select a min price"
                  selectedOption={formData.min_price}
                  items={minPrices.map((price) => ({
                    option: price,
                    value: price,
                  }))}
                  onSelect={handleChange("min_price")}
                />

                <Dropdown
                  placeholder="Select a max price"
                  selectedOption={formData.max_price}
                  items={maxPrices.map((price) => ({
                    option: price,
                    value: price,
                  }))}
                  onSelect={handleChange("max_price")}
                />
              </div>
            )}
            {isActive === "lg" && (
              <div className="flex flex-1 xl:justify-center  xs:gap-2 gap-4">
                <Dropdown
                  placeholder="Select State"
                  selectedOption={formData.state}
                  items={stateNames.map((state) => ({
                    option: state,
                    value: state,
                  }))}
                  onSelect={(value: string) => {
                    handleChange("state")(value);
                    handleChange("local_government")("");
                  }}
                />

                <Dropdown
                  placeholder="Local Government"
                  selectedOption={formData.local_government}
                  items={localGovernments.map((lga) => ({
                    option: lga,
                    value: lga,
                  }))}
                  onSelect={handleChange("local_government")}
                />
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
});

PropertySearchForm.displayName = "PropertySearchForm";
export default PropertySearchForm;

export const InputBtn: React.FC<{ placeholder: string; isActive: boolean }> = ({
  placeholder,
  isActive,
  ...props
}) => {
  return (
    <div
      style={{ backgroundColor: "rgba(var(--primary-color-rgb), 0.1)" }}
      className={`flex justify-between   w-full h-full gap-3 rounded-md ${
        !isActive ? "border-label-main" : "border-themeColor"
      } items-center p-3`}
      {...props}
    >
      <span className="text-sm  font-semibold text-themeColor whitespace-nowrap">
        {placeholder}
      </span>
      <span
        className={`transition-all duration-500 ${
          !isActive ? "rotate-0" : "rotate-[180deg]"
        }`}
      >
        <ArrowDown />
      </span>
    </div>
  );
};

export const ArrowDown = () => {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1780_8299)">
        <path
          d="M2.15122 1.45104C2.09553 1.39841 2.03002 1.35727 1.95843 1.32996C1.88683 1.30265 1.81056 1.28971 1.73397 1.29188C1.65738 1.29405 1.58196 1.31128 1.51203 1.34259C1.4421 1.3739 1.37901 1.41868 1.32639 1.47437C1.27376 1.53007 1.23262 1.59558 1.20531 1.66717C1.178 1.73876 1.16506 1.81503 1.16723 1.89162C1.16939 1.96822 1.18662 2.04363 1.21794 2.11357C1.24925 2.1835 1.29403 2.24658 1.34972 2.29921L6.59972 7.25754C6.70803 7.35994 6.85142 7.41699 7.00047 7.41699C7.14952 7.41699 7.29291 7.35994 7.40122 7.25754L12.6518 2.29921C12.7087 2.24693 12.7547 2.18386 12.787 2.11367C12.8193 2.04348 12.8374 1.96757 12.8401 1.89034C12.8429 1.8131 12.8303 1.7361 12.803 1.66379C12.7757 1.59148 12.7344 1.52531 12.6813 1.46913C12.6282 1.41294 12.5645 1.36785 12.4939 1.33649C12.4233 1.30513 12.3471 1.28811 12.2699 1.28643C12.1926 1.28474 12.1158 1.29843 12.0439 1.32669C11.9719 1.35495 11.9063 1.39722 11.8509 1.45104L7.00047 6.03138L2.15122 1.45104Z"
          fill="var(--primary-color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_1780_8299">
          <rect
            width="8.75"
            height="14"
            fill="white"
            transform="matrix(0 -1 1 0 0 8.875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

interface DropdownProps {
  items: { option: string; value: string }[];
  selectedOption: string;
  onSelect: (value: string) => void;
  placeholder?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  items,
  selectedOption,
  onSelect,
  placeholder = "Select an option",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close dropdown if clicked outside
  useOutsideClick([buttonRef, menuRef], () => setIsOpen(false));
  const toggleDropdown = () => setIsOpen((prev) => !prev);
  return (
    <div className="relative flex-1">
      {/* Dropdown Button */}
      <div
        ref={buttonRef}
        style={{ backgroundColor: "rgba(var(--primary-color-rgb), 0.1)" }}
        className="type-btns w-full whitespace-nowrap flex-1 font-semibold  py-3 text-themeColor rounded-md cursor-pointer flex items-center gap-2"
        onClick={toggleDropdown}
      >
        {selectedOption || placeholder}
        <ArrowIcon isUp={isOpen} />
      </div>

      {/* Dropdown Menu */}
      <LazyMotion features={domAnimation}>
        <AnimatePresence>
          {isOpen && (
            <m.div
              ref={menuRef}
              className="absolute max-h-[200px] w-max scrollbar-hide overflow-y-auto top-full left-0 mt-1 bg-white shadow-lg rounded-md z-10 overflow-hidden"
              initial={{ scaleY: 0, opacity: 0, transformOrigin: "top" }}
              animate={{ scaleY: 1, opacity: 1 }}
              exit={{ scaleY: 0, opacity: 0 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
            >
              {items.map((option) => (
                <div
                  key={option.option}
                  className={`px-5 py-2 cursor-pointer hover:bg-themeColor hover:text-white ${
                    selectedOption === option.option
                      ? "bg-themeColor text-white"
                      : "text-label-main"
                  }`}
                  onClick={() => {
                    onSelect(option.value);
                    setIsOpen(false);
                  }}
                >
                  {option.option}
                </div>
              ))}
            </m.div>
          )}
        </AnimatePresence>
      </LazyMotion>
    </div>
  );
};
